// import countriesData from './countriesData';
import ipAddressData from './ipAddressData';
import shortlyData from './shortlyData';
import textifyData from './textifyData';
import notesData from './notesData';
import devcareerData from './devcareerData';
// import courserateData from './courserateData';
import myListData from './myListData';
import mangaHavenData from './mangaHavenData';

const projects = [
  myListData,
  mangaHavenData,
//   courserateData,
//   countriesData,
  textifyData,
  ipAddressData,
  shortlyData,
  devcareerData,
  notesData,
];

export default projects;
